var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['radio-btn',
     {'active': _vm.checked},
     {'light': _vm.light},
     {'small': _vm.small},
     {'disabled': _vm.disabled},
     {'hide-radio': _vm.hideRadio}],on:{"click":function($event){return _vm.click()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }